import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import type { QualityPreset } from "./quality";

gsap.registerPlugin(ScrollTrigger);

export type ScrollHandle = {
  progress: number;
  destroy: () => void;
};

export function createScrollExperience(
  track: HTMLElement,
  quality: QualityPreset,
  onProgress: (p: number) => void,
): ScrollHandle {
  let progress = 0;

  if (quality.reducedMotion) {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      progress = max > 0 ? window.scrollY / max : 0;
      onProgress(progress);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return {
      get progress() {
        return progress;
      },
      destroy: () => window.removeEventListener("scroll", onScroll),
    };
  }

  const lenis = new Lenis({
    duration: 1.15,
    smoothWheel: true,
  });

  lenis.on("scroll", ScrollTrigger.update);

  const ticker = (time: number) => {
    lenis.raf(time * 1000);
  };
  gsap.ticker.add(ticker);
  gsap.ticker.lagSmoothing(0);

  const st = ScrollTrigger.create({
    trigger: track,
    start: "top top",
    end: "bottom bottom",
    scrub: 0.75,
    onUpdate: (self) => {
      progress = self.progress;
      onProgress(progress);
    },
  });

  return {
    get progress() {
      return progress;
    },
    destroy: () => {
      st.kill();
      gsap.ticker.remove(ticker);
      lenis.destroy();
    },
  };
}
